<div class="row">
  <div class="col-sm-12">
    <fieldset [disabled]="!isEditing">
      <select class="form-group form-control" [ngModel]="$safeNavigationMigration(currentSystemInitStep?.InitStepId)" (ngModelChange)="setSystemStep($event)">
        <option [ngValue]="null">Select...</option>
        @for (item of initSteps; track item.Id) {
          <option [ngValue]="item.Id" [title]="item.Description">{{item.Name}}</option>
        }
      </select>
      @if (disassembleDisplayGroups.length) {
        <ep-datafield-group-container [formValidationGroup]="disassembleFormGroup" [showError]="true" [datafieldGroups]="disassembleDisplayGroups" [isAlwaysEditable]="isEditing" [numberOfColumns]="2">
        </ep-datafield-group-container>
      }
    </fieldset>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    @if (isEditing) {
      <div class="btn-group">
        <button class="btn btn-primary" [disabled]="disassembleFormGroup.invalid" (click)="save()">Save</button>
      </div>
      <div class="btn-group">
        <button class="btn btn-link" (click)="cancelEditMode()">Cancel</button>
      </div>
    }
    @else {
      <div class="btn-group">
        <button class="btn btn-primary" (click)="enterEditMode()">Edit</button>
      </div>
    }
  </div>
</div>
